<template>
  <div class="content1">
    <div class="query_con">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item label="徽章类型">
          <el-select
            v-model="query.cardType"
            placeholder="请选择徽章类型"
            style="width: 200px"
            @change="queryData"
          >
            <el-option
              v-for="item in optionsType"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-date-picker
            v-model="medalDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            style="width: 260px"
            @change="queryData"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button class="add" @click="queryParams">查询</el-button>
          <!-- <el-button class="add" @click="handleExport">导入</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="table_con">
      <el-table
        :data="tableData"
        border
        style="width: 50%"
        v-loading="tableLoading"
        :height="windowHeight"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          prop="cardTypeName"
          label="徽章类型"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="sendNumber"
          label="合计发送数量"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="point"
          label="合计产生积分"
          align="center"
          min-width="80"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_con">
      <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="pageData.page"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="pageData.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
import moment from "moment";
export default {
  name: "badgeMaintain",
  data() {
    return {
      query: {
        cardType: "",
      },
      medalDate: "",
      pageData: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      tableData: [],
      tableLoading: false,
      windowHeight: 350,
      isShowRecord: 1,
      optionsType: []
    };
  },
  mounted() {
    this.upload = api.upload;
    this.imgUrl = api.imgUrl;
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.queryData();
    this.queryType();
  },
  // 组件销毁时移除事件监听器
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 300;
      });
    },
    queryParams() {
      this.queryData();
    },

    // 导入
    handleExport() {
      this.$refs.exportDialog.dialogVisible = true;
    },
    // 选择table
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 分页
    handleSizeChange1(val) {
      this.pageData.pageSize = val;
      this.queryData();
    },
    // 当前页数
    handleCurrentChange1(val) {
      this.pageData.page = val;
      this.queryData();
    },

    // 查询 列表
    queryData() {
      const json = {
        ...this.pageData,
        ...this.query,
        startTime: this.medalDate
          ? moment(this.medalDate[0]).format("YYYY-MM-DD")
          : "",
        endTime: this.medalDate
          ? moment(this.medalDate[1]).format("YYYY-MM-DD")
          : ""
      };
      this.tableLoading = true;
      api
        .queryMedalStatistics(json)
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    // 查询类型
    queryType() {
      api.queryByType({ type: "cardType" }).then(res => {
        if (res.code == 200) {
          this.optionsType = res.data;
          this.optionsType.unshift({
            key: "",
            value: "全部"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.content1 {
  background-color: #f2fcf9;

  .query_con {
    // margin: 30px 40px 20px 40px;
    padding: 40px 0 0px 40px;
    // border: 1px solid #e5e5e5;
    border-radius: 5px;
    ::v-deep {
      .el-date-editor .el-range-separator {
        padding: 0 28px;
      }
    }
    .add {
      color: #fff;
      background-color: #23c0d8;
      border-color: #23c0d8;
    }
  }
  .operate {
    margin: 20px 40px;
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  .table_con {
    background-color: #fff;
    border: 1px solid #e2e6e5;
    padding: 40px 20px;
    margin: 0 40px;
    border-radius: 5px;
  }
  .pagination_con {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    padding-right: 40px;
  }
  .dialog-footer {
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  ::v-deep .hide .el-upload--picture-card {
    display: none;
  }
}
</style>
